import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DbService } from 'src/app/services/db.service';

@Component({
  selector: 'filetostring',
  templateUrl: './filetostring.component.html',
  styleUrls: ['./filetostring.component.css']
})
export class FiletostringComponent implements OnInit {
  @Output() emitFileAsString = new EventEmitter();
  input: any = {};
  fileData: any = "";
  fileName = "";
  hasFile = false;
  constructor(private db: DbService) { }

  ngOnInit(): void {
  }

  fileChangeEvent($event: any) {
    const file = $event.srcElement.files[0]
    this.fileName = file.name
    this.input = new FormData()
    this.input.append('file', file)
    this.hasFile = true
  }

  async uploadFile(){
    const resp = await this.db.post('Scenario', 'uploadImage', this.input)
    let result = {fileName: this.fileName, fileData: resp.data}
    this.emitFileAsString.emit(result)
    this.hasFile = false
    this.fileName = "";
    this.fileData = "";
  }
}
